<template lang="pug">
.buy-vip
  vipPackageList(@currentChoose="currentChoose" :isSVip="isSVip" :isLogin="isLogin" @currentIsHaveWalfare="currentIsHaveWalfare")
  buyVipWay(:currentPackage="currentPackage" :orderType="orderType" :isHaveWalfare="isHaveWalfare" :vipInfo="vipInfo" :isSVip="isSVip" :isLogin="isLogin" :useView="'vip'")
</template>
<script>
import vipPackageList from './vipPackageList.vue';
import buyVipWay from './buyVipWay.vue';

export default {
  name: 'buyVipPc',
  components: {
    vipPackageList,
    buyVipWay,
  },
  props: ['isSVip', 'isLogin', 'vipInfo'],
  data() {
    return {
      currentPackage: {},
      orderType: 0, // 会员套餐
      isHaveWalfare: false,
    };
  },
  methods: {
    // 获取当前选择的会员套餐
    currentChoose(item) {
      this.currentPackage = item;
    },
    currentIsHaveWalfare(val) {
      this.isHaveWalfare = val;
    },
  },
};
</script>
